export const sendEvent = (event, data) => {
  window.dispatchEvent(new CustomEvent(event, { detail: data }));
}

export const sleep = async (time) => {
  await new Promise((r) => {
    setTimeout(r, time);
  });
}

export const inViewport = (element) => {
  const box = element.getBoundingClientRect();
  return box.top < window.innerHeight && box.bottom >= 0;
}

export const jsonAttribute = (base64) => {
  return JSON.parse(atob(base64));
}

export const cookieFactory = {
  set: (name, value, days, secure = true, sameSite = 'Strict') => {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 86400000);
      expires = '; expires=' + date.toUTCString();
    }

    let cookieStr = `${name}=${encodeURIComponent(value)}${expires}; path=/`;

    if (secure) {
      cookieStr += '; Secure';
    }

    if (sameSite) {
      cookieStr += `; SameSite=${sameSite}`;
    }

    document.cookie = cookieStr;
  },
  get: (name) => {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return decodeURIComponent(c.substring(nameEQ.length, c.length));
      }
    }
    return null;
  },
};
